/**
 * @module utils/shuffle
 * @description Fisher-Yates shuffle – returns a new array without mutating the original.
 */

/**
 * Shuffle an array using the Fisher-Yates algorithm.
 * @template T
 * @param {T[]} array - The array to shuffle.
 * @returns {T[]} A new shuffled copy of the array.
 */
export const shuffle = (array) => {
  const arr = array.slice();
  for (let i = arr.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [arr[i], arr[j]] = [arr[j], arr[i]];
  }
  return arr;
};
